<span class="cart-summary-totals__label">Subtotal</span>
<span class="cart-summary-totals__value">{{ checkoutEnabled ? (subtotal | currency) : 'TBD' }}</span>

<ng-container *ngIf="shouldShowConvenienceFee">
    <span class="cart-summary-totals__label cart-summary-totals__label--convenience-fee" aria-live="polite">
        <span>
            {{ feeConfig?.label ?? "Convenience Fee" }}{{ convenienceFee != null && feeConfig?.format === 'percent' ? ' ' + (feeConfig?.rate | percent : '0.1-2') : '' }}
        </span>

        <button mat-icon-button type="button"
                *ngIf="feeConfig?.note"
                (click)="onClick_showConvenienceFeeNote()"
                [attr.aria-label]="'Information about ' + (feeConfig?.label ?? 'convenience fees')"
                aria-live="off">
            <mat-icon svgIcon="info"></mat-icon>
        </button>
    </span>

    <span class="cart-summary-totals__value" *ngIf="!calculating">{{ convenienceFee | currency }}</span>
    <mat-spinner class="cart-summary-totals__value" *ngIf="calculating" [diameter]="iconSize" color="accent"></mat-spinner>
</ng-container>

<mat-divider *ngIf="showDividerBeforeTotal" class="cart-summary-totals__divider"></mat-divider>

<span class="cart-summary-totals__label cart-summary-totals__label--total">Total</span>
<span class="cart-summary-totals__value cart-summary-totals__value--total" *ngIf="!calculating">{{ !checkoutEnabled || total == null ? 'TBD' : (total | currency) }}</span>
<mat-spinner class="cart-summary-totals__value" *ngIf="calculating" [diameter]="iconSize" color="accent"></mat-spinner>
